/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesArticleSummary } from '../../models/sales-article-summary';

export interface ApiProductsquerySalesarticlesCategoryCategoryIdGet$Params {
  categoryId: number;
  subCategoryId?: number;
  take?: number;
  skip?: number;
}

export function apiProductsquerySalesarticlesCategoryCategoryIdGet(http: HttpClient, rootUrl: string, params: ApiProductsquerySalesarticlesCategoryCategoryIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
  const rb = new RequestBuilder(rootUrl, apiProductsquerySalesarticlesCategoryCategoryIdGet.PATH, 'get');
  if (params) {
    rb.path('categoryId', params.categoryId, {});
    rb.query('subCategoryId', params.subCategoryId, {});
    rb.query('take', params.take, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SalesArticleSummary>>;
    })
  );
}

apiProductsquerySalesarticlesCategoryCategoryIdGet.PATH = '/api/productsquery/salesarticles/category/{categoryId}';
